/*
 * Settings Page Panel Template
 */
import type {
  PanelArea,
  PanelsBreakpointTemplate,
  PanelsTemplate,
  SettingsPanelArea,
} from '../types';
import {
  LARGE_NAV_DEFAULT_WIDTH,
  MEDIUM_NAV_DEFAULT_WIDTH,
  MEDIUM_NAV_MAX_WIDTH,
  MEDIUM_NAV_MIN_WIDTH,
} from './constants';

/**
 * Base template (Mobile +)
 */
export function baseTemplate(): PanelsBreakpointTemplate {
  return {
    areas: [['settingsNav', 'settingsPage']],
    resizers: {},
    columns: [
      {
        key: 'settingsNav',
        defaultMin: 200,
        defaultSize: 200,
        defaultMax: 400,
        isToggleable: false,
        showing: false,
      },
      {
        key: 'settingsPage',
        defaultMin: 300,
        defaultSize: '1fr',
        isToggleable: false,
      },
    ],
    rows: [
      {
        key: 'defaultRow',
        defaultMin: 200,
        defaultSize: '1fr',
        isToggleable: false,
      },
    ],
  };
}

/**
 * Medium template
 */
export const mediumTemplate = (): PanelsBreakpointTemplate => {
  return {
    areas: [['settingsNav', 'settingsPage']],
    resizers: {},
    columns: [
      {
        key: 'settingsNav',
        defaultMin: MEDIUM_NAV_MIN_WIDTH,
        defaultSize: MEDIUM_NAV_DEFAULT_WIDTH,
        defaultMax: MEDIUM_NAV_MAX_WIDTH,
        isToggleable: false,
      },
      {
        key: 'settingsPage',
        defaultMin: 300,
        defaultSize: '1fr',
        isToggleable: false,
      },
    ],
    rows: [
      {
        key: 'defaultRow',
        defaultMin: 200,
        defaultSize: '1fr',
        isToggleable: false,
      },
    ],
  };
};

/**
 * Large template
 */
export const largeTemplate = (): PanelsBreakpointTemplate => {
  return {
    areas: [['settingsNav', 'settingsPage']],
    resizers: {},
    columns: [
      {
        key: 'settingsNav',
        defaultMin: MEDIUM_NAV_MIN_WIDTH,
        defaultSize: LARGE_NAV_DEFAULT_WIDTH,
        defaultMax: MEDIUM_NAV_MAX_WIDTH,
        isToggleable: false,
      },
      {
        key: 'settingsPage',
        defaultMin: 300,
        defaultSize: '1fr',
        isToggleable: false,
      },
    ],
    rows: [
      {
        key: 'defaultRow',
        defaultMin: 200,
        defaultSize: '1fr',
        isToggleable: false,
      },
    ],
  };
};

export const getDefaultVisiblePanels = (): Array<SettingsPanelArea> => {
  return ['settingsNav', 'settingsPage'];
};

export function getPanelState(__visible: Array<PanelArea>): PanelsTemplate {
  return {
    base: baseTemplate(),
    tablet: mediumTemplate(),
    desktop: largeTemplate(),
    visible: ['settingsNav', 'settingsPage'],
  };
}
